export default __webpack_public_path__ + "static/media/iread6.55de21d1.jpeg";